class ProductImageZoom {
  constructor() {
    this.lensSize = 200;        // Desktop
    this.mobileLensSize = 235;  // Mobile
    this.zoomLevel = 2.0;
    this.mobileOffsetY = -115;  // Lupe etwas über dem Finger

    this.longPressDelay = 220;
    this.touchStartTimer = null;
    this.isTouchZoomActive = false;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchMoveTolerance = 8;

    this.lastTouchClientX = 0;
    this.lastTouchClientY = 0;

    // Hint bleibt sichtbar bis erster Tap
    this.hasUserTouched = false;

    this.init();
  }

  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setupZoom());
    } else {
      this.setupZoom();
    }

    document.addEventListener("variant:changed", () => {
      setTimeout(() => this.setupZoom(), 150);
    });

    // Kontextmenü blocken
    document.addEventListener("contextmenu", (e) => {
      if (
        e.target.closest(".product-gallery__media") ||
        e.target.closest('[data-media-type="image"]')
      ) {
        e.preventDefault();
      }
    });
  }

  setupZoom() {
    let mediaWrappers = document.querySelectorAll(".product-gallery__media");

    if (mediaWrappers.length === 0) {
      mediaWrappers = document.querySelectorAll('[data-media-type="image"]');
    }

    if (mediaWrappers.length === 0) return;

    const isMobile = window.innerWidth < 1000;

    mediaWrappers.forEach((wrapper) => {
      if (wrapper.classList.contains("zoom-initialized")) return;

      const img = wrapper.querySelector("img");
      if (!img) return;

      if (wrapper.querySelector("video") || wrapper.querySelector("model-viewer")) {
        return;
      }

      wrapper.classList.add("zoom-initialized");

      const wrapperStyle = getComputedStyle(wrapper);
      if (wrapperStyle.position === "static") {
        wrapper.style.position = "relative";
      }

      // Lupe
      const lens = document.createElement("div");
      lens.className = "zoom-lens";

      const currentLensSize = isMobile ? this.mobileLensSize : this.lensSize;
      lens.style.width = currentLensSize + "px";
      lens.style.height = currentLensSize + "px";

      const highResUrl = this.getHighResUrl(img.src);
      lens.style.backgroundImage = "url('" + highResUrl + "')";
      lens.style.backgroundRepeat = "no-repeat";
      lens.style.backgroundPosition = "center";
      lens.style.position = "absolute";
      lens.style.pointerEvents = "none";
      lens.style.borderRadius = "50%";
      lens.style.border = "1px solid rgba(0,0,0,0.15)";
      lens.style.boxShadow = "0 4px 12px rgba(0,0,0,0.2)";
      lens.style.opacity = "0";
      lens.style.transition = "opacity 0.12s ease";
      lens.style.zIndex = "15";

      wrapper.appendChild(lens);

      if (isMobile) {
        if (!this.hasUserTouched) {
          this.addTouchHint(wrapper);
        }
        this.attachMobileEvents(wrapper, img, lens);
      } else {
        this.attachDesktopEvents(wrapper, img, lens);
      }
    });
  }

  // Hint oben rechts (ca 85%), bleibt bis erster Tap

  addTouchHint(wrapper) {
    if (wrapper.querySelector(".zoom-touch-hint")) return;

    const hint = document.createElement("div");
    hint.className = "zoom-touch-hint";

    hint.innerHTML = `
      <img src="https://cdn.shopify.com/s/files/1/0030/2510/9038/files/press_hold.webp?v=1765228871" alt="Press & Hold" />
      <span>Press &amp; Hold</span>
    `;

    hint.style.position = "absolute";
    hint.style.top = "16px";
    hint.style.left = "88%";
    hint.style.transform = "translateX(-50%)";

    hint.style.display = "flex";
    hint.style.flexDirection = "column";
    hint.style.alignItems = "center";
    hint.style.justifyContent = "center";

    hint.style.background = "transparent";
    hint.style.pointerEvents = "none";
    hint.style.zIndex = "200";

    hint.style.opacity = "0";
    hint.style.transition = "opacity 0.35s ease";

    const icon = hint.querySelector("img");
    icon.style.width = "40px";
    icon.style.height = "40px";
    icon.style.marginBottom = "3px";
    icon.style.objectFit = "contain";
    icon.style.filter = "brightness(1.6)";
    icon.style.dropShadow = "4px 4px 16px rgba(0,0,0,0.6)";

    const span = hint.querySelector("span");
    span.style.fontSize = "12px";
    span.style.fontWeight = "700";
    span.style.color = "#fff";
    span.style.textShadow = "4px 4px 16px rgba(0,0,0,0.7)";

    wrapper.appendChild(hint);

    requestAnimationFrame(() => {
      hint.style.opacity = "1";
    });
  }

  hideAllTouchHints() {
    const hints = document.querySelectorAll(".zoom-touch-hint");
    hints.forEach((hint) => {
      hint.style.opacity = "0";
      setTimeout(() => {
        if (hint.parentNode) hint.parentNode.removeChild(hint);
      }, 350);
    });
  }

  // Desktop Hover

  attachDesktopEvents(wrapper, img, lens) {
    wrapper.addEventListener("mouseenter", (e) => {
      wrapper.classList.add("zoom-active");
      lens.style.opacity = "1";
      this.updateLens(e, img, lens, this.lensSize);
    });

    wrapper.addEventListener("mouseleave", () => {
      wrapper.classList.remove("zoom-active");
      lens.style.opacity = "0";
    });

    wrapper.addEventListener("mousemove", (e) => {
      if (!wrapper.classList.contains("zoom-active")) return;
      this.updateLens(e, img, lens, this.lensSize);
    });
  }

  // Mobile Press and Hold direkt auf wrapper

  attachMobileEvents(wrapper, img, lens) {
    wrapper.addEventListener(
      "touchstart",
      (e) => {
        if (e.touches.length !== 1) return;

        if (!this.hasUserTouched) {
          this.hasUserTouched = true;
          this.hideAllTouchHints();
        }

        const touch = e.touches[0];

        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
        this.lastTouchClientX = touch.clientX;
        this.lastTouchClientY = touch.clientY;
        this.isTouchZoomActive = false;

        this.clearTouchTimer();

        this.touchStartTimer = setTimeout(() => {
          this.isTouchZoomActive = true;
          wrapper.classList.add("zoom-active");
          lens.style.opacity = "1";

          const fakeTouch = {
            clientX: this.lastTouchClientX,
            clientY: this.lastTouchClientY
          };
          this.updateLensTouch(fakeTouch, img, lens, this.mobileLensSize);
        }, this.longPressDelay);
      },
      { passive: true }
    );

    wrapper.addEventListener(
      "touchmove",
      (e) => {
        if (e.touches.length !== 1) return;

        const touch = e.touches[0];
        this.lastTouchClientX = touch.clientX;
        this.lastTouchClientY = touch.clientY;

        // Zoom noch nicht aktiv → nichts blockieren, Swipe geht zum Slider
        if (!this.isTouchZoomActive) {
          const dx = Math.abs(touch.clientX - this.touchStartX);
          const dy = Math.abs(touch.clientY - this.touchStartY);

          // User swipet → Longpress abbrechen
          if (dx > this.touchMoveTolerance || dy > this.touchMoveTolerance) {
            this.clearTouchTimer();
          }
          return;
        }

        // Zoom aktiv → Slider blocken
        e.preventDefault();
        this.updateLensTouch(touch, img, lens, this.mobileLensSize);
      },
      { passive: false }
    );

    wrapper.addEventListener(
      "touchend",
      () => {
        this.clearTouchTimer();

        if (this.isTouchZoomActive) {
          wrapper.classList.remove("zoom-active");
          lens.style.opacity = "0";
          this.isTouchZoomActive = false;
        }
      },
      { passive: true }
    );

    wrapper.addEventListener(
      "touchcancel",
      () => {
        this.clearTouchTimer();

        if (this.isTouchZoomActive) {
          wrapper.classList.remove("zoom-active");
          lens.style.opacity = "0";
          this.isTouchZoomActive = false;
        }
      },
      { passive: true }
    );
  }

  clearTouchTimer() {
    if (this.touchStartTimer) {
      clearTimeout(this.touchStartTimer);
      this.touchStartTimer = null;
    }
  }

  // Positionierung Lupe

  updateLens(e, img, lens, lensSize) {
    const rect = img.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    this.positionLens(x, y, rect, lens, lensSize, false);
  }

  updateLensTouch(touch, img, lens, lensSize) {
    const rect = img.getBoundingClientRect();
    const x = touch.clientX - rect.left;
    const y = touch.clientY - rect.top;
    this.positionLens(x, y, rect, lens, lensSize, true);
  }

  positionLens(x, y, rect, lens, lensSize, isMobile) {
    const halfLens = lensSize / 2;

    let displayY = isMobile ? y + this.mobileOffsetY : y;

    let lensX = x - halfLens;
    let lensY = displayY - halfLens;

    if (lensX < 0) lensX = 0;
    if (lensX > rect.width - lensSize) lensX = rect.width - lensSize;
    if (lensY < 0) lensY = 0;
    if (lensY > rect.height - lensSize) lensY = rect.height - lensSize;

    lens.style.left = lensX + "px";
    lens.style.top = lensY + "px";

    const bgX = -(x * this.zoomLevel - halfLens);
    const bgY = -(displayY * this.zoomLevel - halfLens);

    lens.style.backgroundPosition = bgX + "px " + bgY + "px";
    lens.style.backgroundSize =
      rect.width * this.zoomLevel + "px " + rect.height * this.zoomLevel + "px";
  }

  getHighResUrl(url) {
    let cleanUrl = url.split("?")[0];
    cleanUrl = cleanUrl.replace(
      /(_\d+x\d+|_pico|_icon|_thumb|_small|_compact|_medium|_large|_grande|_original|_1024x1024|_2048x2048|_master)\.(jpg|jpeg|png|gif|webp)$/i,
      ".$2"
    );
    return cleanUrl + "?width=2000";
  }

  destroy() {
    const mediaWrappers = document.querySelectorAll(
      ".product-gallery__media.zoom-initialized, [data-media-type=\"image\"].zoom-initialized"
    );

    mediaWrappers.forEach((wrapper) => {
      wrapper.classList.remove("zoom-initialized", "zoom-active");

      const lens = wrapper.querySelector(".zoom-lens");
      if (lens) lens.remove();

      const hint = wrapper.querySelector(".zoom-touch-hint");
      if (hint) hint.remove();
    });
  }
}

// Initialisierung
const productZoom = new ProductImageZoom();
window.productImageZoom = productZoom;
